import server from "./server";

export const postUserLogin = async (data) => {
  const response = await server().post("/auth/login", data);
  return response.data;
};

export const getCurrentUserApi = async (data) => {
  const response = await server().get("/auth/currentUser", data);
  return response.data;
};
